<template>
  <div class="imageWrap">
    <van-image
      fit="cover"
      error-icon=""
      loading-icon=""
      :width="imageSize + 'px'"
      :height="imageSize + 'px'"
      :src="getGoodsImageUrl()"
    />
  </div>
</template>

<style lang="less" scoped>
.imageWrap {
  position: relative;
  .imageFlag {
    position: absolute;
    z-index: 1;
  }
}
</style>

<script>
import { Image as vanImage } from 'vant';
import 'vant/lib/image/style';

export default {
  components: {
    vanImage,
  },
  props: {
    imageSize: {
      type: Number,
      default: 120,
    },
    skuInfo: {
      type: Object
    }
  },
  data() {
    return {
      splitFlagImg: require("../assets/icon_split_flag.png")
    }
  },
  methods: {
    getGoodsImageUrl() {
      return `${this.skuInfo && this.skuInfo.image}`.split("|")[0]
        || this.getConfig('defaultImageUrl')
    },
  }
}
</script>